import { actionCreatorFactory } from 'typescript-fsa'
import { SubControl } from '../../types'

const actionCreator = actionCreatorFactory()

export const registerSubControls = actionCreator<SubControl[]>(
	'registerSubControls',
)
